'use client'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useUI } from '@corratech/pylot-ui/context'
import { ChevronUp } from '@components/icons'
import s from './ScrollUpButton.module.scss'

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false)
    const router = useRouter()
    const { displaySidebar, displayBottomDrawer } = useUI()

    // Solo mostrar si no es checkout, pdp, carrito abierto ni drawer de tallas
    const shouldShow =
        !router.pathname.includes('checkout') &&
        !router.pathname.includes('producto') &&
        !displaySidebar &&
        !displayBottomDrawer

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 300)
        }

        window.addEventListener('scroll', toggleVisibility)
        return () => window.removeEventListener('scroll', toggleVisibility)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    if (!shouldShow) return null

    return (
        <button
            onClick={scrollToTop}
            style={{
                opacity: isVisible ? 1 : 0,
                pointerEvents: isVisible ? 'auto' : 'none'
            }}
            className={s['button-up-scroll']}
        >
            <ChevronUp />
        </button>
    )
}

export default ScrollToTopButton
